export default {
    apiKey: "AIzaSyDzpRFe5PZjo1qlEbwb3C1U4hDp6Rf0JAw",
    authDomain: "worshipph.firebaseapp.com",
    databaseURL: "https://worshipph.firebaseio.com",
    projectId: "worshipph",
    storageBucket: "worshipph.appspot.com",
    messagingSenderId: "623204593449",
    appId: "1:623204593449:web:4cb75297bce4843e5fd138",
    measurementId: "G-KTRLHFQ0SY"
};